import RegistrationForm from "../../components/RegistrationForm/RegistrationForm";

const RegistrationPage = () => {
  return (
    <div>
      <RegistrationForm />
    </div>
  );
};

export default RegistrationPage;
